<template>
    <postulant-details-component :ui="'sales_advisor'" :routeToList="'employee-postulants-list-SA'"></postulant-details-component>
</template>

<script>
import PostulantDetailsComponent from '@/components/Admin-Employee/Postulant/Details/PostulantDetailsComponent.vue'

export default {
    name: "PostulantDetails",
    components: { PostulantDetailsComponent },
    data: () => ({}),
}
</script>